export async function uploadToCloudinary(file: File, userId?: string): Promise<string> {
  const cloudName = import.meta.env.VITE_CLOUDINARY_CLOUD_NAME;
  const uploadPreset = import.meta.env.VITE_CLOUDINARY_UPLOAD_PRESET;

  if (!cloudName || !uploadPreset) {
    throw new Error('Missing Cloudinary configuration.');
  }

  // ✅ Use auto to support audio, video, and images
  const resourceType = 'auto';

  const formData = new FormData();
  formData.append('file', file);
  formData.append('upload_preset', uploadPreset);

  if (userId) {
    // Optional: Store files in a single folder for this user
    formData.append('folder', `uploads/${userId}`);
  }

  // ❌ REMOVED: Transformation parameters (not allowed with unsigned presets)
  // ✅ We'll handle CORS at the URL level instead

  console.log('🔄 Uploading to Cloudinary...', { 
    fileName: file.name, 
    fileType: file.type, 
    userId 
  });

  const res = await fetch(
    `https://api.cloudinary.com/v1_1/${cloudName}/${resourceType}/upload`,
    {
      method: 'POST',
      body: formData,
    }
  );

  if (!res.ok) {
    const errorText = await res.text();
    console.error('❌ Cloudinary upload failed:', errorText);
    throw new Error(`Cloudinary upload failed: ${errorText}`);
  }

  const data = await res.json();
  const originalUrl = data.secure_url as string;
  
  // ✅ For images, modify the URL to add CORS support without server-side transformations
  let finalUrl = originalUrl;
  
  if (file.type.startsWith('image/')) {
    // Instead of using fl_cross_origin transformation, we'll handle CORS in the component
    // The CORSImage component will add proper attributes and handle retries
    finalUrl = originalUrl;
  }
  
  console.log('✅ Cloudinary upload successful:', {
    original: originalUrl,
    final: finalUrl,
    isImage: file.type.startsWith('image/')
  });
  
  return finalUrl;
}